import { telemetry } from "../../constants";
import { createModalData } from "./createModalData/createModalData";
import { safeString, Tracker } from "../../helpers";
export function makeOpenBetBoostDetails({ retriever, bonusId, dictionary, boostSelections, originalBoostSelections, openModal, }) {
    return () => {
        var _a;
        Tracker.getInstance().trackEvent(telemetry.events.myBets, {
            ClientType: telemetry.clientType,
            Action: telemetry.actions.myBets.openBoostLadder,
            CurrentTab: safeString((_a = retriever.lastRequest().filter) === null || _a === void 0 ? void 0 : _a.status),
            MyBetsVersion: telemetry.version,
        });
        const boostDetails = retriever.bonusDetails.get(bonusId);
        if (typeof boostDetails !== "undefined") {
            openModal(createModalData(boostDetails, dictionary, boostSelections, originalBoostSelections));
        }
        else {
            retriever.getBonusDetailsById({
                playerBonusId: bonusId,
            }).then(details => {
                openModal(createModalData(details, dictionary, boostSelections, originalBoostSelections));
            }).catch(() => undefined);
        }
    };
}
//# sourceMappingURL=makeOpenBetBoostDetails.js.map